import { useEffect } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { handleTinuitiCookie, trackTinuitiPageView } from '@alltrails/shared/utils/tinuitiUtils';

const useTinuitiPixel = () => {
  const user = useUser();
  const userId = user?.id?.toString();

  useEffect(() => {
    handleTinuitiCookie();
    trackTinuitiPageView(userId);
  }, [userId]);
};

export default useTinuitiPixel;
